<template>
    <div class="guochan-download">
        <!-- Logo -->
        <div class="logo-container">
            <img src="../../../assets/image/down_logo.png" alt="峰岭科技" class="logo">
        </div>

        <!-- 主内容区域 -->
        <div class="main-content">
            <!-- 提示文本 -->
            <div class="tip-text">
                <div class="tip-title">更多选择，即将解锁！</div>
                <div class="tip-subtitle">龙芯、飞腾版本现已整装待发！</div>
            </div>

            <!-- 下载卡片区域 -->
            <div class="download-cards">
                <!-- 银河麒麟卡片 -->
                <div class="download-card" @click="downloadKylin">
                    <div class="card-icon">
                        <img src="../../../assets/image/kylin-icon.png" alt="KYLINOS" class="os-icon default-icon">
                        <img src="../../../assets/image/xcdown_white.png" alt="Download" class="os-icon download-icon">
                    </div>
                    <div class="card-footer">
                        <span>麒麟+海光</span>
                    </div>
                </div>

                <!-- 统信桌面卡片 -->
                <div class="download-card" @click="downloadUOS">
                    <div class="card-icon">
                        <img src="../../../assets/image/uos-icon.png" alt="UNIONTECH" class="os-icon default-icon">
                        <img src="../../../assets/image/xcdown_white.png" alt="Download" class="os-icon download-icon">
                    </div>
                    <div class="card-footer">
                        <span>统信+海光</span>
                    </div>
                </div>
            </div>

            <!-- 底部版权信息 -->
            <div class="footer">
                <div class="xc-logo">
                    <img src="../../../assets/image/xclogo.png" alt="信创" class="xc-icon">
                </div>
                <div class="footer-bottom">
                    <div class="copyright">峰岭科技SummitView空间数据浏览器国产信创下载页面</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "GuochanDownload",
    data() {
        return {
            downloadList: [{"id":"kylin","url":"https://pan.baidu.com/s/1y5VVKveDRNwW_o4q4Xybfg?pwd=y9j7"},{"id":"uos","url":"https://pan.baidu.com/s/1MVqi-TBnwmGQEyfO9BgOIA?pwd=ayxj"}]
        };
    },
    methods: {
        // 下载银河麒麟版本
        downloadKylin() {
            let res = this.downloadList.find(n => n.id === 'kylin');
            console.log( res,'res');
            let url = res.url;
            window.open(url, '_blank');
        },
        // 下载统信桌面版本
        downloadUOS() {
          let res = this.downloadList.find(n => n.id == 'uos');
          let url = res.url;
          window.open(url, '_blank');
        }
    }
};
</script>

<style scoped lang="scss">
.guochan-download {
    min-height: calc(100vh - 60px);
    background: linear-gradient(135deg, #4A90E2 0%, #5BA3F5 50%, #7CB8FF 100%);
    position: relative;
    overflow: hidden;
    z-index: 1;

    .logo-container {
        position: fixed;
        top: 80px;
        right: 80px;
        z-index: 5;

        .logo {
            height: 60px;
            width: auto;
            object-fit: contain;
        }
    }

    // 背景装饰圆形
    &::before {
        content: '';
        position: absolute;
        width: 600px;
        height: 600px;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 50%;
        top: -300px;
        left: -200px;
    }

    &::after {
        content: '';
        position: absolute;
        width: 400px;
        height: 400px;
        background: rgba(255, 255, 255, 0.03);
        border-radius: 50%;
        bottom: -100px;
        right: -100px;
    }

    .main-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: calc(100vh - 60px);
        position: relative;
        z-index: 1;
        padding: 60px 20px 40px;

        .tip-text {
            text-align: center;
            margin-bottom: 80px;

            .tip-title {
                font-size: 36px;
                font-weight: 400;
                color: #FFFFFF;
                margin-bottom: 16px;
                text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
            }

            .tip-subtitle {
                font-size: 28px;
                font-weight: 300;
                color: rgba(255, 255, 255, 0.95);
                text-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
            }
        }

        .download-cards {
            display: flex;
            gap: 60px;

            .download-card {
                /*background: rgba(255, 255, 255, 0.15);*/
                backdrop-filter: blur(10px);
                border-radius: 20px;
                cursor: pointer;
                transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                /*border: 1px solid rgba(255, 255, 255, 0.2);*/
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;
                /*box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);*/

                &:hover {

                }

                .card-icon {
                    width: 120px;
                    height: 120px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;

                    .os-icon {
                        width: 120px;
                        height: 120px;
                        object-fit: contain;
                        transition: opacity 0.3s ease;
                        position: absolute;
                    }

                    .default-icon {
                        opacity: 1;
                    }

                    .download-icon {
                        opacity: 0;
                    }
                }

                &:hover {
                    .card-icon {
                        .default-icon {
                            opacity: 0;
                        }

                        .download-icon {
                            opacity: 1;
                        }
                    }
                }

                .card-content {
                    text-align: center;
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                    .os-label {
                        font-size: 14px;
                        font-weight: 500;
                        color: rgba(255, 255, 255, 0.8);
                        letter-spacing: 2px;
                        margin-bottom: 8px;
                    }

                    .os-name {
                        font-size: 28px;
                        font-weight: 600;
                        color: #FFFFFF;
                        margin-bottom: 12px;
                        text-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                    }

                    .os-type {
                        font-size: 20px;
                        font-weight: 400;
                        color: rgba(255, 255, 255, 0.85);
                        letter-spacing: 3px;
                    }
                }

                .card-footer {
                    width: 100%;


                    span {
                      margin-top: 15px;
                        font-size: 14px;
                        color: rgba(255, 255, 255, 0.8);
                        display: block;
                        text-align: center;
                    }
                }
            }
        }

        .footer {
            position: absolute;
            bottom: 30px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 16px;

            .xc-logo {
                display: flex;
                align-items: center;
                justify-content: center;

                .xc-icon {
                    height: 60px;
                    width: auto;
                    object-fit: contain;
                }
            }

            .footer-bottom {
                display: flex;
                align-items: center;

                .shield-icon {
                    display: flex;
                    align-items: center;
                }

                .copyright {
                    font-size: 18px;
                    color: #ffffff;
                }
            }
        }
    }
}

// 响应式设计
@media (max-width: 768px) {
    .guochan-download {
        .logo-container {
            top: 70px;
            right: 20px;

            .logo {
                height: 40px;
            }
        }
    }
}
</style>
